import dom from '../../../wrapper/DomWrapper';
import { GDPR_ANALYTICS_SWITCHER } from '../constants';

const elAnalytics = dom.getElement(GDPR_ANALYTICS_SWITCHER);

export default () => elAnalytics
  && elAnalytics.getAttribute('data-active') === 'true';
